import React from 'react';

export default function SectionWrapper(props) {
  return (
    <div className="container-lg">
        {props.children}
    </div>
  )
}
